import selectableShiftRowUrl from './selectable-shift-row.html';

class SelectableShiftRowCtrl {
  handleClick($event) {
    if (this.disabled) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  onShiftSelect(selectedShift) {
    if (!this.disabled) {
      this.onSelect({ selectedShift });
    }
  }
}

export default {
  controller: SelectableShiftRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    shift: '<',
    onSelect: '&',
    disabled: '=',
  },
  templateUrl: selectableShiftRowUrl,
};
